(function () {
  function setActiveTab(nav, activeTab) {
    var tabs = nav.querySelectorAll('.m-dashboard-tabs__tab');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('is-active');
    }
    activeTab.classList.add('is-active');
  }

  function hideAllPanels() {
    var panels = document.querySelectorAll('.m-dashboard-panel');
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.add('is-hidden');
    }
  }

  function showPanelsFor(tabId) {
    var panels = document.querySelectorAll('.m-dashboard-panel-' + tabId);
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.remove('is-hidden');
    }
    return panels.length;
  }

  /* ── Why this exists ──────────────────────────────────────────────
     Which panel is showing is held in a CSS class that clicks add and
     remove. That state is part of the DOM, so the browser's back/forward
     cache restores it verbatim: leave the Dashboard with the Tips panel
     open, come back to it, and every Home panel is still carrying
     `is-hidden` — a blank page that a manual refresh "fixes", because a
     refresh re-renders from Liquid.

     So never trust the restored classes. On every load, and again on every
     restore, recompute visibility from the tab that is actually marked
     active and force the panels to match. If a tab has no panel on this
     page, fall back to Home rather than hiding everything.
     ───────────────────────────────────────────────────────────────── */
  function syncPanelsToActiveTab() {
    if (!document.querySelector('.m-dashboard-panel')) return;

    var activeTab = document.querySelector('.m-dashboard-tabs__tab.is-active[data-tab-id]');
    var tabId = activeTab ? activeTab.getAttribute('data-tab-id') : 'home';

    hideAllPanels();
    if (!showPanelsFor(tabId)) showPanelsFor('home');
  }

  function syncSpacerHeights() {
    document.querySelectorAll('.m-dashboard-tabs').forEach(function (bar) {
      var id = bar.getAttribute('data-section-id');
      var spacer = document.querySelector('[data-dashboard-tabs-spacer="' + id + '"]');
      if (spacer) {
        spacer.style.height = bar.offsetHeight + 'px';
      }
    });
  }

  function initDashboardTabs(nav) {
    var tabs = nav.querySelectorAll('.m-dashboard-tabs__tab[data-tab-id]');
    var hasPanels = document.querySelectorAll('.m-dashboard-panel').length > 0;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        var tabId = tab.getAttribute('data-tab-id');

        // "Home" only means "swap panels" on pages that actually have panels
        // (the Dashboard). On other pages (Tips, Schemes, etc.) let it navigate
        // to the Dashboard page like a normal link.
        //
        // Home now has a panel of its own (Where You Left Off, and anything
        // else belonging to the Home view), so it has to be shown back
        // explicitly — otherwise Home would hide everything and leave the
        // member staring at a blank page.
        if (tabId === 'home') {
          if (hasPanels) {
            e.preventDefault();
            hideAllPanels();
            showPanelsFor('home');
            setActiveTab(nav, tab);
          }
          return;
        }

        // If a panel for this tab already lives on this page, swap to it instantly.
        var panel = document.querySelector('.m-dashboard-panel-' + tabId);
        if (panel) {
          e.preventDefault();
          hideAllPanels();
          panel.classList.remove('is-hidden');
          setActiveTab(nav, tab);
          return;
        }

        // Otherwise there's no on-page content for this tab yet — let the link navigate normally.
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.m-dashboard-tabs__nav').forEach(initDashboardTabs);
    syncPanelsToActiveTab();
    syncSpacerHeights();
    window.addEventListener('resize', syncSpacerHeights);
    window.addEventListener('load', syncSpacerHeights);
  });

  /* Fires on a normal load AND on a back/forward-cache restore, where
     DOMContentLoaded does not run again. This is the one that rescues the
     blank page. */
  window.addEventListener('pageshow', function () {
    syncPanelsToActiveTab();
    syncSpacerHeights();
  });

  /* The Theme Editor swaps section markup over AJAX, which can drop a panel
     back in carrying whatever classes it was saved with. */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.m-dashboard-tabs__nav').forEach(initDashboardTabs);
    syncPanelsToActiveTab();
    syncSpacerHeights();
  });
})();
